<app-page hideSidebar="true">
  <creators-leaderboard></creators-leaderboard>
</app-page>
